<section id="journals-featured-Articles" class="journals" aria-label="section" *ngIf="articleData.length > 0">
    <div class="container">
        <div class="section-title" data-aos="fade-up" *ngIf="section === 'recent'">
            <h2 class="primary" tabindex="0">{{'journal_home.recent_articles' | translate}}</h2>
            <p tabindex="0" class="rvh-sub-heading">Stay up to date with our latest articles.</p>
        </div>
        <div class="section-title" data-aos="fade-up" *ngIf="section === 'fasttrack'">
            <h2 class="primary" tabindex="0">{{'journal_home.fasttrack_articles' | translate}}</h2>
            <p tabindex="0" class="rvh-sub-heading">Explore our fasttrack articles.</p>
        </div>
        <div class="section-title" data-aos="fade-up" *ngIf="section === 'featured'">
            <h2 class="primary" tabindex="0">{{'journal_home.featured_articles' | translate}}</h2>
            <p class="rvh-sub-heading"  tabindex="0">Find out what's trending in our featured articles.</p>
        </div>
        <div class="section-title" data-aos="fade-up" *ngIf="section === 'most_downloaded'">
            <h2 class="primary"  tabindex="0"> {{'journal_home.most_downloaded_articles' | translate}}</h2>
            <p class="rvh-sub-heading"  tabindex="0">Explore our most downloaded articles of all time.</p>
        </div>
        <div class="section-title" data-aos="fade-up" *ngIf="section === 'most_viewed'">
            <h2 class="primary"  tabindex="0">{{'journal_home.most_viewed_articles' | translate}}</h2>
            <p class="rvh-sub-heading"  tabindex="0">See which articles our readers are viewing most.</p>
        </div>
        <img class="img-fluid img-rect-left position-absolute ml-1" src="assets/images/Rectangle 501.webp" alt="">

        <!-- ======= Journal cards section ======= -->
        <div class="row d-flex align-items-stretch">
            <div *ngFor="let article of articleData"
                class="col-lg-3 col-md-4 col-sm-1 z-index box-height mt-4 margin-div" data-aos="fade-up"
                data-aos-delay="100">
                <div class="card" style="width: 100%">
                    <img src='assets/logos/open_access_logo.webp' class="open-access-logo" title="Open Access">
                    
                    <img  tabindex="0" *ngIf="article.article_cover_image" class="card-img-top rvh-article-home-cover-img"
                        src="{{articleCoverImageUrl+getArticleImageUrl(article)}}" [alt]="article.cover_alt_text">
                    <img  tabindex="0" *ngIf="!article.article_cover_image" class="card-img-top rvh-article-home-cover-img"
                        src="{{defaultCoverImage}}" [alt]="'common.default_cover_image'|translate" >
                    <div class="card-body pt-2"  >
                        <p class="card-text about-article" [innerHTML]="article.article_title"  *ngIf="section !== 'fasttrack'"
                            [routerLink]="['/journal/'+journalid+ '/articles/'+article.volume+'/'+article.issue+'/'+article.article_id]">
                        </p>
                        <p class="card-text about-article" [innerHTML]="article.article_title" *ngIf="section === 'fasttrack'"
                        [routerLink]="['/journal/'+journalid+ '/articles/'+'/fasttrack/'+article.volume+'/'+article.issue+'/'+article.article_id]">
                        </p>
                        
                        <p  tabindex="0" class="card-text article-volume">Volume {{article.volume}}, Issue {{article.issue}}</p>
                        <p   tabindex="0" class="card-text article-date">Published on {{article.published_online}}</p>
                            <p class="card-text article-volume" tabindex="0" >
                                <span class="line-clamp-2" title="{{getAuthorNames(article.authors)}}">
                                    {{getAuthorNames(article.authors) }}
                                </span>
                            </p>
                    </div>
                   
                </div>
            </div>
        </div>
        <!-- ======= End Journal cards section ======= -->
        <p class="fw-bold md-subhead fx-bold text-color-blue text-align-end rvh-view-more" data-aos="fade-right" *ngIf="section !== 'fasttrack'">
            <a [routerLink]="['/journal/'+journalid+'/articles/page/1']" [queryParams]="queryParams" title="{{'journal_home.view_all' | translate}}" > 
                 {{'journal_home.view_all' | translate}}
                <fa-icon class="iconcls" aria-hidden="true" [icon]="['fas', 'circle-arrow-right']"></fa-icon>
            </a>
        </p>
        <p class="fw-bold md-subhead fx-bold text-color-blue text-align-end rvh-view-more" data-aos="fade-right" *ngIf="section === 'fasttrack'">
                <a [routerLink]="['/journal/'+journalid+'/articles/fasttrack/page/1']" [queryParams]="queryParams"  
                title="{{'journal_home.view_all' | translate}}" > 
                     {{'journal_home.view_all' | translate}}
                    <fa-icon class="iconcls" aria-hidden="true" [icon]="['fas', 'circle-arrow-right']"></fa-icon>
                </a>
            </p>
    </div>
</section>